﻿import React from 'react';

import { GenerateReport } from 'components/GenerateReport/GenerateReport';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { Report, ReportComponent } from 'apis/ReportApi';
import { Col } from 'react-bootstrap';

interface SubReportProps {
	component: ReportComponent;
	currentSubReport: Report | undefined;
	index: number;
	loading: boolean;
	renderComponents: (component: ReportComponent, loading: boolean, index: number) => void | JSX.Element;
}

export const SubReport = ({ component, currentSubReport, index, loading, renderComponents }: SubReportProps) => {

    if (currentSubReport) {

        return (
            <Col
                className="component-wrapper__col rounded-1 rounded-start-0"
                id={index.toString()}
                key={`${component.ComponentId}-${index}`}
                lg={component.WidthLg}
                md={component.WidthMd}
                sm={component.WidthSm}
                style={{ backgroundColor: '#E2E6ED' }}
                xl={component.WidthXl}
            >
                {loading ? (
                    <GMetrixLoader className="find-content-dialog__loader" />
                ) : (
                    <>
                        <Col className="sub-report py-1" key={`${component.ComponentId}-${index}`}>
                            <GenerateReport
                                isSubReport
                                reportId={currentSubReport.Id}
                                scopeId={currentSubReport.ScopeId}
                                scopeObjectId={currentSubReport.ScopeObjectId}
                            />
                        </Col>
                    </>
                )}
            </Col>
        );

    } else {

        return (
            <Col
                className="component-wrapper__col"
                key={`${component.ComponentId}-${index}`}
                lg={component.WidthLg}
                md={component.WidthMd}
                sm={component.WidthSm}
                xl={component.WidthXl}
            >
                {loading ? <GMetrixLoader className="find-content-dialog__loader" /> : <></>}
            </Col>
        );

    }

};
